import Image from 'next/image'
import { useState } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'
import { FCC } from '~/core/@types/global'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '~/core/ui/Accordion'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import SectionContainer from '../LandingPage/components/section/SectionContainer'
import LPContainer from './LPContainer'

const SlickSlider = Slider as unknown as React.FC<any>

const JobAndCandidateSection: FCC<{ className?: string }> = ({}) => {
  const { t } = useTranslation()
  const [value, setValueChange] = useState(`item-0`)

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: false,
    focusOnSelect: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots'
  }

  const SECTIONS = [
    {
      contentTitle: t('allFeature:job_and_candidate:section_1_content_title'),
      contentDescription: t(
        'allFeature:job_and_candidate:section_1_content_description'
      ),
      contentImage:
        '/img/feature/lp/new/talent-intelligence-job-candidate01.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:job_and_candidate:section_2_content_title'),
      contentDescription: t(
        'allFeature:job_and_candidate:section_2_content_description'
      ),
      contentImage:
        '/img/feature/lp/new/talent-intelligence-job-candidate02.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:job_and_candidate:section_3_content_title'),
      contentDescription: t(
        'allFeature:job_and_candidate:section_3_content_description'
      ),
      contentImage:
        '/img/feature/lp/new/talent-intelligence-job-candidate03.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:job_and_candidate:section_4_content_title'),
      contentDescription: t(
        'allFeature:job_and_candidate:section_4_content_description'
      ),
      contentImage:
        '/img/feature/lp/new/talent-intelligence-job-candidate04.png',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="allFeature:job_and_candidate:title"
      description="allFeature:job_and_candidate:description"
      tagLabel="allFeature:job_and_candidate:tag"
      tagColor="bg-green-100 text-green-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <LPContainer className="mt-6 px-0 tablet:px-4">
        {!isMobile || isTablet ? (
          <div className="flex items-center">
            <div className="flex-1 pr-[95px]">
              <Accordion
                type="single"
                collapsible
                value={value}
                onValueChange={setValueChange}>
                {SECTIONS?.map((faqItem, index) => {
                  const getItem = `item-${index}`
                  const isSelected = value === getItem
                  const { contentTitle, contentDescription } = faqItem

                  return (
                    <AccordionItem
                      key={index}
                      className={cn(
                        'px-8 py-4',
                        isSelected
                          ? 'border-l-[3px] border-primary-400'
                          : 'border-l border-gray-300'
                      )}
                      value={getItem}>
                      <AccordionTrigger
                        id={`arrow-title-${index}`}
                        className="cursor-pointer">
                        <TypographyText
                          className={cn(
                            'text-2xl font-medium',
                            isSelected ? 'text-gray-900' : 'text-gray-500'
                          )}>
                          {contentTitle}
                        </TypographyText>
                      </AccordionTrigger>
                      <AccordionContent className="text-base font-normal text-gray-600 mt-2">
                        {contentDescription}
                      </AccordionContent>
                    </AccordionItem>
                  )
                })}
              </Accordion>
            </div>

            <div className="rounded-lg bg-gray-100">
              <Image
                src={SECTIONS[Number(value?.replace('item-', ''))].contentImage}
                width={495}
                height={0}
                alt={`feature ${SECTIONS[Number(value?.replace('item-', ''))].contentTitle}`}
                className="h-auto"
              />
            </div>
          </div>
        ) : (
          <div className="relative">
            <SlickSlider {...settings} className="mb-6 tablet:mb-0">
              {SECTIONS.map((item, index) => (
                <div
                  key={`screenshot-image-${index}`}
                  className="animate-fadeInUp !border-0 !outline-0">
                  <div>
                    <TypographyText className="text-1.5xl font-medium text-gray-900">
                      {item.contentTitle}
                    </TypographyText>
                    <TypographyText className="text-base font-normal text-gray-700 mt-1.5 mb-2">
                      {item.contentDescription}
                    </TypographyText>
                  </div>

                  <div className="rounded-lg bg-gray-100 p-5">
                    <img src={item.contentImage} alt={`screenshot ${index}`} />
                  </div>
                </div>
              ))}
            </SlickSlider>
          </div>
        )}
      </LPContainer>
    </SectionContainer>
  )
}

export default JobAndCandidateSection
